import { Component, Inject, OnInit } from "@angular/core";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
} from "@azure/msal-browser";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { SessionService } from "../../@core/session/session.service";
import { IDGenerator } from "../../@core/utils/id-generator.util";
import { AppLocalStorage } from "../../@core/utils/local-storage.util";
import { HttpClient } from "@angular/common/http";
import { Session } from "../../@core/session/session.model";
import {  Router } from '@angular/router';

@Component({
  selector: "ltts-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginDisplay: boolean;
  private readonly _destroying$ = new Subject<void>();
  session: { token: any; id: any; expiry: any };

  constructor(private msalService: MsalService,private router: Router) {}

  ngOnInit(): void {
    this.checkAccount();
  }

  login(): void {
    this.msalService.loginRedirect();
  }

  checkAccount(): void {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      // Set the active account if available
      this.msalService.instance.setActiveAccount(accounts[0]);
      //this.router.navigate(['/home']);
    }else{
      //this.login();
    }
  }

  // setLoginDisplay() {
  //   this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  // }

  // checkAndSetActiveAccount() {
  //   /**
  //    * If no active account set but there are accounts signed in, sets first account to active account
  //    * To use active account set here, subscribe to inProgress$ first in your component
  //    * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
  //    */
  //   let activeAccount = this.authService.instance.getActiveAccount();

  //   if (
  //     !activeAccount &&
  //     this.authService.instance.getAllAccounts().length > 0
  //   ) {
  //     let accounts = this.authService.instance.getAllAccounts();
  //     this.authService.instance.setActiveAccount(accounts[0]);
  //   }

  // }

  // loginRedirect() {
  //   if (this.msalGuardConfig.authRequest) {
  //     this.authService.instance.loginRedirect({
  //       ...this.msalGuardConfig.authRequest,
  //     } as RedirectRequest);
  //   } else {
  //     this.authService.instance.loginRedirect();
  //   }
  // }

  // loginPopup() {
  //   if (this.msalGuardConfig.authRequest) {
  //     this.authService
  //       .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
  //       .subscribe((response: AuthenticationResult) => {
  //         this.authService.instance.setActiveAccount(response.account);
  //         this.session = {
  //           token: response.accessToken,
  //           id: IDGenerator.newId(),
  //           expiry: null,
  //         };
  //         AppLocalStorage.set("SESSION", "SESSION", this.session);
  //         this.getCalendarEvents(response.account);
  //         this.sessionService.loadAccount();
  //       });
  //   } else {
  //     this.authService
  //       .loginPopup()
  //       .subscribe((response: AuthenticationResult) => {
  //         this.authService.instance.setActiveAccount(response.account);
  //         this.sessionService.loadAccount();
  //       });
  //   }
  // }

  // getCalendarEvents(account) {
  //   // const account = this.authService.instance.getActiveAccount();
  //   if (account) {
  //     this.authService
  //       .acquireTokenSilent({
  //         scopes: ["calendars.read"],
  //         account: account,
  //       })
  //       .subscribe({
  //         next: (response) => {

  //           AppLocalStorage.set(
  //             "CALENDAR_TOKEN",
  //             "CALENDAR_TOKEN",
  //             response.accessToken
  //           );
  //           // this.http.get('https://graph.microsoft.com/v1.0/me/events', {
  //           //   headers: {
  //           //     Authorization: `Bearer ${response.accessToken}`
  //           //   }
  //           // }).subscribe(events => {
  //           // });
  //         },
  //         error: (error) => {
  //           // Handle the error or try to acquire a token interactively if needed
  //         },
  //       });
  //   }
  // }

  // logout(popup?: boolean) {
  //   if (popup) {
  //     this.authService.logoutPopup({});
  //   } else {
  //     this.authService.logoutRedirect();
  //   }
  // }
  // ngOnDestroy(): void {
  //   this._destroying$.next(undefined);
  //   this._destroying$.complete();
  // }
}
